<template>
  <div style="width: 94vw">
    <el-container style="padding: 25px 25px">
      <div class="bbb1">

        <el-header style="display: flex;height: 40px;">


          <span class="style-title">游戏名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini" @change="changeGame()"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <span class="style-title">日期:</span>

          <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
              size="mini"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions3">
          </el-date-picker>


          <el-select v-show="optionsPerson.length>1" v-model="person" placeholder="人员选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsPerson"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>


          <el-dropdown
              trigger="hover"
              style="margin-left: 10px;margin-top: 9px;"
              @command="handleAccountLevelChange"
              placement="bottom-start"
          >
            <el-button size="mini">
              账户层级<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                  v-for="option in accountLevelOptions"
                  :key="option.value"
                  :command="option.value">
                <el-checkbox
                    :value="selectedAccountLevel === option.value"
                    @change="(val) => handleAccountLevelChange(option.value)" style="margin-right: 8px;">
                </el-checkbox>
                {{ option.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>
          <!-- 添加筛选框切换按钮 -->
          <el-button
              size="mini"
              style="margin-left: 10px; margin-top: 5px;"
              @click="showAdvancedFilter = !showAdvancedFilter"
              :type="showAdvancedFilter ? 'primary' : 'default'"
          >
            {{ showAdvancedFilter ? '收起筛选' : '高级筛选' }}
            <i :class="showAdvancedFilter ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>


          <download-excel :data="exportData" :fields="exportFields" :name="exportName"
                          :autoWidth="true" :bookType="'xlsx'">
            <el-button size="mini"
                       style="margin-left: 10px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                       icon="el-icon-download">
              导出
            </el-button>
          </download-excel>
                    <el-upload
                        action="#"
                        :before-upload="handleFileRead"
                        accept=".xlsx,.xls,.csv"
                        :show-file-list="false">
                      <el-button
                          size="mini"      style="margin-left: 10px; height: 30px; margin-top: 8px;"
                          type="primary"
                          icon="el-icon-upload2">
                        导入
                      </el-button>
                    </el-upload>
        </el-header>
        <!-- 高级筛选框 -->
        <el-collapse-transition>
          <div v-show="showAdvancedFilter" class="advanced-filter-container"
               style="margin-top: 15px; padding: 15px; background: #f8f9fa; border-radius: 4px;">
            <div style="display: flex; flex-wrap: wrap; gap: 15px; align-items: center;">
              <!-- 第n日ROI -->
              <div style="display: flex; align-items: center;">
                <span class="style-title">第n日ROI:</span>
                <el-input-number
                    v-model="filterParams.nthDayRoi"
                    :min="1"
                    :max="150"
                    size="mini"
                    style="width: 80px; margin-left: 5px;"
                    placeholder="输入天数">
                </el-input-number>
              </div>

              <!-- 连续n日 -->
              <div style="display: flex; align-items: center;">
                <span class="style-title">连续n日:</span>
                <el-input-number
                    v-model="filterParams.consecutiveDays"
                    :min="1"
                    :max="30"
                    size="mini"
                    style="width: 80px; margin-left: 5px;"
                    placeholder="输入天数">
                </el-input-number>
              </div>


              <!-- ROI对比游戏 -->
              <div style="display: flex; align-items: center;">
                <span class="style-title">ROI对比游戏:</span>
                <el-select
                    v-model="filterParams.roiOperator"
                    size="mini" style="width: 100px; margin-left: 5px;">
                  <el-option label="≥" value="gte"></el-option>
                  <!--                  <el-option label=">" value="gt"></el-option>-->
                  <el-option label="≤" value="lte"></el-option>
                  <!--                  <el-option label="<" value="lt"></el-option>-->
                  <!--                  <el-option label="=" value="eq"></el-option>-->
                </el-select>
                <el-input-number
                    v-model="filterParams.roiCompare"
                    :precision="2"
                    :step="10"
                    :min="-100"
                    size="mini" style="width: 130px; margin-left: 5px;"
                    placeholder="输入数值">
                </el-input-number>
                <el-tooltip
                    effect="dark"
                    content="(该计划创意roi-游戏roi)/游戏roi*100大于等于-填写的值"
                    placement="top">
                  <i class="el-icon-question" style="margin-left: 5px; cursor: pointer; color: #909399;"></i>
                </el-tooltip>
              </div>

              <!-- 且/或 条件 -->
              <div style="display: flex; align-items: center;">
                <span class="style-title">条件关系:</span>
                <el-radio-group v-model="filterParams.conditionType" size="mini" style="margin-left: 5px;">
                  <el-radio-button label="and">且</el-radio-button>
                  <el-radio-button label="or">或</el-radio-button>
                </el-radio-group>
              </div>

              <!-- 倍率对比游戏 -->
              <div style="display: flex; align-items: center;">
                <span class="style-title">倍率对比游戏:</span>
                <el-select
                    v-model="filterParams.ratioOperator"
                    size="mini" style="width: 100px; margin-left: 5px;">
                  <el-option label="≥" value="gte"></el-option>
                  <!--                  <el-option label=">" value="gt"></el-option>-->
                  <el-option label="≤" value="lte"></el-option>
                  <!--                  <el-option label="<" value="lt"></el-option>-->
                  <!--                  <el-option label="=" value="eq"></el-option>-->
                </el-select>
                <el-input-number
                    v-model="filterParams.ratioCompare"
                    :precision="2"
                    :step="10"
                    :min="-100"
                    size="mini" style="width: 130px; margin-left: 5px;"
                    placeholder="输入数值">
                </el-input-number>
              </div>
              <!-- 操作按钮 -->
              <div style="display: flex; gap: 10px; margin-left: auto;">
                <el-button size="mini" @click="resetFilters" icon="el-icon-refresh">重置</el-button>
                <el-button size="mini" type="primary" @click="applyFilters" icon="el-icon-search">应用筛选</el-button>
              </div>
            </div>
          </div>
        </el-collapse-transition>
        <el-table
            ref="tableData1"
            :data="paginatedTableData5.filter(data => !person || data.c_author.toLowerCase().includes(person.toLowerCase()))"
            max-height="80vh"
            height="79vh"
            border
            :key="tableKey" style="margin-top: 11px"
            :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
            size="mini"
            :default-sort="{prop: 'statCost', order: 'descending'}"
            v-loading="loading"
            highlight-current-row
            @sort-change="handleSortChange"
        >

          <el-table-column
              v-if="selectedGroupFields.includes('statTimeDay')"
              prop="statTimeDay"
              label="日期"
              sortable
              min-width="130">
          </el-table-column>

          <el-table-column
              v-if="selectedGroupFields.includes('gameName')"
              prop="gameName"
              label="游戏名称"
              min-width="160">
          </el-table-column>

          <el-table-column
              v-if="selectedGroupFields.includes('accountId')"
              prop="accountId"
              label="账户"
              min-width="160">
          </el-table-column>

          <el-table-column
              v-if="selectedGroupFields.includes('projectId')"
              prop="projectId"
              label="项目"
              min-width="160">
          </el-table-column>

          <el-table-column
              v-if="selectedGroupFields.includes('promotionId')"
              prop="promotionId"
              label="计划"
              min-width="160">
          </el-table-column>
          <el-table-column
              v-if="selectedGroupFields.includes('materialId')"
              prop="materialId"
              label="创意"
              min-width="160">
            <template slot-scope="{row}">
      <span @click="showChartForCreative(row)" style="cursor: pointer; color: #409EFF; text-decoration: underline;">
        {{ row.materialId }}
      </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="状态"
              min-width="100">
            <template slot-scope="{row}">
              <span v-if="row.status.system_status_cn === '投放中'" style="color: green;">●</span>
              {{ row.status.system_status_cn }}
            </template>
          </el-table-column>


          <el-table-column
              label="操作"
              width="220"
          >
            <template slot-scope="{row}">
              <div style="display: flex" v-show="row.gameName!==''">
                <el-button @click="jumpJl(row)" icon="el-icon-zoom-in" size="mini">计划</el-button>

                <el-button @click="jump(row)" icon="el-icon-zoom-in" size="mini">素材</el-button>

                <!--              <el-button @click="closeP(row)" type="danger" size="mini">暂停</el-button>--></div>
            </template>

          </el-table-column>
          <el-table-column
              prop="statCost"
              label="消耗"
              sortable
              :formatter="(row, column, cellValue) => formatStatCost(cellValue)"
              min-width="100"

          >

          </el-table-column>
          <el-table-column
              prop="miniGameIncomeRoi1"
              label="激活后24小时roi"
              sortable
              v-if="!selectedGroupFields.includes('materialId')"
              min-width="150">
            <template slot-scope="{row}">
              <span v-html="formatMiniGameIncomeRoi1WithComparison(row)"></span>
            </template>
          </el-table-column>
          <el-table-column
              v-for="day in selectedDays"
              :key="day"
              :prop="'revenues.' + day"
              :label="day + '日roi'"
              :formatter="(row, column, cellValue) => formatRevenueCostRatioWithComparison(row, day)"
              :sort-method="(a, b) => sortRevenueCostRatio(a, b, day)"
              min-width="120"
              sortable>
            <template slot-scope="{row}">
              <span v-html="formatRevenueCostRatioWithComparison(row, day)"></span>
            </template>
          </el-table-column>

          <el-table-column
              prop="roi60"
              label="游戏预估60日roi"
              v-if="selectedAccountLevel==='wu'"
              min-width="150"
          >
            <template slot-scope="{row}">
              <span>{{ formatRoi60Value(row) }}</span>
            </template>

          </el-table-column>


        </el-table>
        <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData5.length"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
        >
        </el-pagination>

        <el-drawer
            :visible.sync="showImportPreview"
            :with-header="true"
            :modal-append-to-body="false"
            direction="rtl"
            size="80%"
            title="导入数据预览"
            custom-class="import-preview-drawer"
            :before-close="closeImportPreview">
          <div class="drawer-content">
            <el-table
                :data="tableClose"
                border
                height="70vh"
                :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
                size="mini">
              <!--              <el-table-column prop="statTimeDay" label="日期" min-width="100"></el-table-column>-->
              <el-table-column prop="gameName" label="游戏名称" min-width="120"></el-table-column>
              <el-table-column prop="accountId" label="账户" min-width="120"></el-table-column>
              <el-table-column prop="projectId" label="项目" min-width="120"></el-table-column>
              <el-table-column prop="promotionId" label="计划" min-width="120"></el-table-column>
              <el-table-column prop="materialId" label="创意" min-width="120"></el-table-column>
              <el-table-column prop="statCost" label="消耗" min-width="100"></el-table-column>
              <!--              <el-table-column prop="miniGameIncomeRoi1" label="激活后24小时roi" min-width="140"></el-table-column>-->
            </el-table>
            <div class="drawer-actions" style="margin-top: 20px;">
              <el-button @click="closeImportPreview" size="small">取消</el-button>
              <!--              <el-button type="primary" @click="confirmImport" size="small">确认导入</el-button>-->
              <el-button type="danger" @click="batchPauseImported" size="small">全部暂停</el-button>
            </div>
          </div>
        </el-drawer>

      </div>


    </el-container>
    <el-drawer
        :visible.sync="showChart"
        :with-header="true"
        :modal-append-to-body="false"
        direction="rtl"
        size="80%"
        :title="chartTitle"
        custom-class="chart-drawer"
        :before-close="closeChart"
    >
      <div class="drawer-content">
        <div class="chart-navigation" v-if="chartData.allDates && chartData.allDates.length > 14">
          <el-button
              @click="prevChartPage"
              :disabled="!showPrevBtn"
              icon="el-icon-arrow-left"
              size="small"
              style="position: absolute; left: 20px; z-index: 100;">
            上一页
          </el-button>
          <div class="page-info" style="text-align: center; margin: 10px 0;">
            {{
              Math.min(chartPageIndex * chartsPerPage + 1, chartData.allDates.length)
            }}-{{ Math.min((chartPageIndex + 1) * chartsPerPage, chartData.allDates.length) }} /
            {{ chartData.allDates.length }} 天
            (固定显示14个)
          </div>
          <el-button
              @click="nextChartPage"
              :disabled="!showNextBtn"
              icon="el-icon-arrow-right"
              size="small"
              style="position: absolute; right: 20px; z-index: 100;">
            下一页
          </el-button>
        </div>
        <div id="roiChart" style="height: 90vh; width: 100%; margin-top: 20px;"></div>
        <div class="drawer-actions">
          <el-button @click="closeChart" size="small">关闭</el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import * as XLSX from "xlsx";
import {readImportRowsWithRawIds} from '@/utils/excelImport';
import axios from "axios";

const cityOptions = ['游戏名', '日期'];
const cityOptions2 = ['ROI', '倍率'];
const cityOptions3 = ['游戏名', '日期', '品类'];
export default {
  name: "ProjectBroad",

  data() {

    return {
// 在 data() 函数中更新 accountLevelOptions 数组
      accountLevelOptions: [
        {value: 'account', label: '账户', fields: ['accountId']},
        {value: 'account-project', label: '账户和项目', fields: ['accountId', 'projectId']},
        {
          value: 'account-project-promotion',
          label: '账户、项目、计划',
          fields: ['accountId', 'projectId', 'promotionId']
        },
        {
          value: 'account-project-promotion-material',
          label: '账户、项目、计划、创意',
          fields: ['accountId', 'projectId', 'promotionId', 'materialId']
        },
        {value: 'account-project-material', label: '账户、项目、创意', fields: ['accountId', 'projectId', 'materialId']},
        {value: 'account-material', label: '账户、创意', fields: ['accountId', 'materialId']},
        {value: 'material', label: '创意', fields: ['materialId']},
        {value: 'wu', label: '以都不选', fields: []},

      ],
      hierarchyFields: ['accountId', 'projectId', 'promotionId', 'materialId'],
      baseGroupOptions: [
        {value: 'date', label: '日期'}
      ],

      // 当前选中的基础分组
      selectedBaseGroup: 'game',
      groupByFields: ['statTimeDay', 'gameName', 'accountId', 'projectId', 'promotionId', 'materialId'],
      selectedGroupFields: ['gameName', 'accountId', 'projectId', 'promotionId', 'materialId'], // 移除 statTimeDay
      selectedGroupFields2: ['statTimeDay', 'gameName', 'accountId', 'projectId', 'promotionId', 'materialId'], // 保持包含日期，用于图表数据准备
      selectedGroupFields3: ['statTimeDay', 'gameName', 'accountId', 'projectId', 'promotionId'],
      showChart: false,
      roiDays: [3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      tableData5: [],
      yType: "2",
      dialogFormVisible: false,
      checkedCities: ['游戏名', '日期'],

      checkedCities2: ['ROI', '倍率'],
      activeName: 'first',
      cities: cityOptions,
      checkedYugu: ['游戏名', '日期'],
      citiesYugu: cityOptions3,
      cities2: cityOptions2,
      isSort: true,
      list: [],
      value1: [],
      currentPage: 1,
      valueScene: '',
      fl: false,
      tableDataY4: [],
      loading: false,
      registerDate: "",
      type: 'pv',
      pageSize: 50,
      valueUser: "",
      avgEcpm: 0,
      value5: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近二个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      gameType: '',
      tableDataType: [],
      tableData: [],//营收
      tableData2: [],
      optionsGame: [],
      optionsPerson: [],
      optionsDay: ['按最新', 3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      valueDay: 60,
      valuePerson: "",
      valueGame: "",
      value: 0,
      value2: '',
      value3: 7,
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      selectedDays: [1, 2, 3, 4, 5, 6, 7], isSearch: true,
      person: '',
      form: {
        allDivisionScale: 0,
        divisionScale: 0.1,
        type: '流量主比例',
        date: [],
        checked: true
      },
      formLabelWidth: '140px',
      summaryRow: null,
      tableKey: 0,
      sortBy: 'statCost',           // 默认排序字段
      sortOrder: 'descending',
      selectedAccountLevel: 'account-project-promotion-material',
      chartData: {},     // 图表数据
      chartTitle: '',    // 图表标题
      chartPageIndex: 0, // 图表当前页索引
      chartsPerPage: 14,  // 每页显示的天数
      showPrevBtn: false, // 是否显示上一页按钮
      showNextBtn: false, // 是否显示下一页按钮
      originalRawData: [],
      priceData: [],
      priceType: '',
      showAdvancedFilter: false,
      filterParams: {
        nthDayRoi: 3,         // 第n日ROI，默认为2
        consecutiveDays: 2,   // 连续n日，默认为3
        conditionType: 'and', // 条件关系，默认为且
        roiCompare: -20,      // ROI对比游戏，默认为0.1
        ratioCompare: -20,     // 倍率对比游戏，默认为0.2
        roiOperator: 'lte',
        ratioOperator: 'lte',


      },
      filteredDataMap: {},
      tableClose: [],
      showImportPreview: false,  // 控制导入预览抽屉显示
      importedData: [],
      statusCache: {},


    }


  }, computed: {

    exportData() {
      // 返回要导出的数据
      return this.formatExportData();
    },
    exportFields() {
      // 定义要导出的字段
      const fields = {};

      // 根据 selectedGroupFields 动态添加字段
      if (this.selectedGroupFields.includes('statTimeDay')) {
        fields['日期'] = 'statTimeDay';
      }
      if (this.selectedGroupFields.includes('gameName')) {
        fields['游戏名称'] = 'gameName';
      }
      if (this.selectedGroupFields.includes('accountId')) {
        fields['账户'] = 'accountId';
      }
      if (this.selectedGroupFields.includes('projectId')) {
        fields['项目'] = 'projectId';
      }
      if (this.selectedGroupFields.includes('promotionId')) {
        fields['计划'] = 'promotionId';
      }
      if (this.selectedGroupFields.includes('materialId')) {
        fields['创意'] = 'materialId';
      }

      // 固定添加的字段
      fields['消耗'] = 'statCost';

      if (!this.selectedGroupFields.includes('materialId') && this.tableData5 && this.tableData5.length > 0 && this.tableData5[0].miniGameIncomeRoi1 !== undefined) {
        fields['激活后24小时roi'] = 'miniGameIncomeRoi1';
      }

      // 添加选中的天数ROI字段
      this.selectedDays.forEach(day => {
        fields[`${day}日roi`] = `revenues.${day}`;
      });


      fields['地址'] = 'url'
      return fields;
    },
    exportName() {
      // 定义导出文件名
      const gameName = this.valueGame || '全部游戏';
      const dateRange = this.value2 ? `${this.value2[0]}-${this.value2[1]}` : '未知日期';
      return `${gameName}_${dateRange}_投放数据.xlsx`;
    },
    uniqueGameTypes() {
      // 从 tableData 中提取唯一的 gameType 值
      const gameTypes = this.tableDataType
          .map(item => item.gameType)
          .filter(type => type !== undefined && type !== null && type !== '');

      // 使用 Set 去重
      return [...new Set(gameTypes)];
    },

    paginatedTableData5() {
      if (!this.tableData5 || this.tableData5.length === 0) {
        return [];
      }

      // 先排序再分页
      let sortedData = [...this.tableData5];

      // 根据当前排序字段和顺序进行排序
      if (this.sortBy && this.sortOrder) {
        sortedData.sort((a, b) => {
          let aValue = a[this.sortBy];
          let bValue = b[this.sortBy];

          // 处理特殊字段
          if (this.sortBy === 'statCost') {
            aValue = parseFloat(aValue) || 0;
            bValue = parseFloat(bValue) || 0;
          }

          if (this.sortOrder === 'ascending') {
            return aValue > bValue ? 1 : -1;
          } else {
            return aValue < bValue ? 1 : -1;
          }
        });
      }

      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;

      const lastData = sortedData.slice(start, end)

      console.log("分页数据===", lastData)
      console.log(this.statusCache)
      lastData.forEach(item => {

        const key = `${item.accountId}-${item.materialId}`;

        if (this.statusCache[key]) {
          console.log("缓存数据===", this.statusCache[key])

      this.$set(item, 'status', this.statusCache[key]);
        }

      })

console.log(this.statusCache)

      console.log("最终===,", lastData)

      return lastData;
    }

  }, watch: {

    colOptions(valArr) {
      // alert("sss");
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    }
  },
  filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else {

        return value.toFixed(2)

      }
    },
    dataFilters3(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')


      }
    }, dataFilters4(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {

        return value.toFixed(2) + '%'
      }

    }
  }, methods: {

    handleFileRead(file) {
      // 阻止上传行为
      this.readFileData(file);
      return false; // 阻止默认上传行为
    },

    readFileData(file) {
      try {
        // 检查文件类型
        const fileName = (file.name || '').toLowerCase();
        const isExcel = fileName.endsWith('.xlsx') ||
            fileName.endsWith('.xls') ||
            fileName.endsWith('.csv');

        if (!isExcel) {
          this.$message.error('请上传 Excel 或 CSV 文件！');
          return;
        }

        // 使用 SheetJS 读取文件
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, {type: 'array'});
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = readImportRowsWithRawIds(workbook, firstSheet, data, file.name);

            // 转换数据格式以匹配组件数据结构
            const convertedData = this.convertToComponentFormat(jsonData);

            this.tableClose = convertedData;

            console.log("导入数据:", convertedData)
            this.showImportPreview = true;

            if (this.hasPossibleRoundedImportIds(convertedData)) {
              this.$message.warning('导入成功，但检测到部分长ID可能已被表格转换为近似值，请确认ID列为文本格式后重新导入');
            } else {
              this.$message.success('数据导入成功！');
            }
          } catch (error) {
            this.$message.error('文件解析失败：' + error.message);
          }
        };

        // 读取文件
        reader.readAsArrayBuffer(file);
      } catch (error) {
        this.$message.error('文件读取失败：' + error.message);
      }

      // 阻止默认上传行为
      return false;
    },
    closeImportPreview() {
      this.showImportPreview = false;
      this.tableClose = [];
    },
    normalizeImportId(value) {
      if (value === undefined || value === null) {
        return '';
      }
      if (typeof value === 'number') {
        if (!Number.isFinite(value)) {
          return '';
        }
        return Number.isInteger(value)
            ? value.toLocaleString('fullwide', {useGrouping: false})
            : String(value);
      }
      return String(value).replace(/'/g, '').replace(/\t/g, '').replace(/,/g, '').trim();
    },
    hasPossibleRoundedImportIds(rows) {
      const idFields = ['accountId', 'projectId', 'promotionId', 'materialId'];
      return (rows || []).some(row => idFields.some(field => {
        const value = this.normalizeImportId(row[field]);
        return /^\d{18,}$/.test(value) && /0{3,}$/.test(value);
      }));
    },
    normalizePauseId(value) {
      return this.normalizeImportId(value);
    },
    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds));
    },
    convertToComponentFormat(jsonData) {
      return jsonData.map(item => {
        // 根据导入的字段名映射到组件所需的数据结构
        return {
          statTimeDay: item['日期'] || item['statTimeDay'] || item['date'] || '',
          gameName: item['游戏名称'] || item['gameName'] || item['game'] || '',
          accountId: this.normalizeImportId(item['账户'] || item['accountId'] || item['account']),
          projectId: this.normalizeImportId(item['项目'] || item['projectId'] || item['project']),
          promotionId: this.normalizeImportId(item['计划'] || item['promotionId'] || item['promotion']),
          materialId: this.normalizeImportId(item['创意'] || item['materialId'] || item['material']),
          statCost: parseFloat(item['消耗'] || item['statCost'] || item['cost'] || 0) || 0,
          miniGameIncomeRoi1: parseFloat(item['激活后24小时roi'] || item['miniGameIncomeRoi1'] || 0) || 0,
          revenues: this.extractRevenueData(item),
          roi60: parseFloat(item['游戏预估60日roi'] || item['roi60'] || 0) || 0
        };
      });
    },
    extractRevenueData(item) {
      const revenues = {};
      // 提取所有包含"日roi"的字段
      Object.keys(item).forEach(key => {
        const match = key.match(/(\d+)日roi|(\d+)dayroi/i);
        if (match) {
          const day = match[1] || match[2];
          revenues[day] = parseFloat(item[key]) || 0;
        }
      });
      return revenues;
    },
    async batchPauseImported() {
      if (!this.tableClose || this.tableClose.length === 0) {
        this.$message.warning('没有可暂停的数据');
        return;
      }

      try {
        this.$confirm(
            `确定要暂停 ${this.tableClose.length} 个创意吗？`,
            '批量暂停确认',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(async () => {
          const results = [];

          // 批量处理暂停请求
          for (const item of this.tableClose) {
            try {
              const accountId = this.normalizePauseId(item.accountId);
              const materialId = this.normalizePauseId(item.materialId);
              if (!accountId || !materialId) {
                throw new Error('创意ID或账号ID为空，无法暂停');
              }
              await this.$axios.post('/toufangWx/data/closePromtionId', {
                "configured_status": "AD_STATUS_SUSPEND",
                "account_id": accountId,
                "dynamic_creative_id": materialId,
                "aadvid": accountId
              });
              results.push({status: 'fulfilled'});
            } catch (error) {
              console.error(`暂停创意 ${item.materialId} 失败:`, error);
              results.push({status: 'rejected', reason: error});
            }
            await this.sleep(800);
          }

          // 统计成功和失败的数量
          const successful = results.filter(result => result.status === 'fulfilled').length;
          const failed = results.filter(result => result.status === 'rejected').length;

          if (failed === 0) {
            this.$message.success(`批量暂停成功！共暂停 ${successful} 个创意`);
          } else {
            this.$message.info(`批量暂停完成！成功 ${successful} 个，失败 ${failed} 个`);
          }

          this.closeImportPreview();
        });
      } catch (error) {
        console.error('批量暂停过程中发生错误:', error);
        this.$message.error('批量暂停过程中发生错误');
      }
    },
    jumpJl(row) {

      window.open("https://ad.qq.com/atlas/" + row.accountId + "/admanage/index?tab=adgroup&query={%22operation_status%22:[%22CALCULATE_STATUS_EXCLUDE_DEL%22],%22system_status%22:[],%22search_name%22:%22" + row.promotionId + "%22}" + "&a=" + Math.random()
      )

    },
    jump(row) {
      window.open("https://ad.qq.com/atlas/" + row.accountId + "/admanage/index?tab=dynamic_creative&query={%22operation_status%22:[%22CALCULATE_STATUS_EXCLUDE_DEL%22],%22created_time%22:-29,%22fuzzy_name%22:%22" + row.materialId + "%22}")

    },
    formatExportData() {
      if (!this.tableData5 || !Array.isArray(this.tableData5)) {
        return [];
      }

      return this.tableData5.map(item => {
        const exportedItem = {};

        // 根据 selectedGroupFields 动态添加字段
        if (this.selectedGroupFields.includes('statTimeDay')) {
          exportedItem.statTimeDay = String(item.statTimeDay || '');
        }
        if (this.selectedGroupFields.includes('gameName')) {
          exportedItem.gameName = String(item.gameName || '');
        }
        if (this.selectedGroupFields.includes('accountId')) {
          exportedItem.accountId = String('\t' + item.accountId || '');
        }
        if (this.selectedGroupFields.includes('projectId')) {
          exportedItem.projectId = String('\t' + item.projectId || '');
        }
        if (this.selectedGroupFields.includes('promotionId')) {
          exportedItem.promotionId = String('\t' + item.promotionId || '');
        }

        exportedItem.materialId = `'${item.materialId}`;  // 双引号包装
        exportedItem.promotionId = `'${item.promotionId}`;
        exportedItem.accountId = `'${item.accountId}`;
        exportedItem.projectId = `'${item.projectId}`;
        // 格式化消耗字段为字符串
        exportedItem.statCost = String(parseFloat(item.statCost || 0).toFixed(2));
        exportedItem.url = "https://ad.oceanengine.com/material_center/analysis/video/" + item.materialId + "?aadvid=" + item.accountId + "&end_time=2025-01-30&start_time=2036-01-23"
        // 格式化ROI相关字段
        if (item.miniGameIncomeRoi1 !== undefined) {
          const roi1 = item.miniGameIncomeRoi1 || 0;
          const cost = item.statCost || 0;
          const ratio = (cost !== 0) ? (roi1 / cost) : 0;
          exportedItem.miniGameIncomeRoi1 = String(ratio.toFixed(2) + '%');
        }

        // 格式化各天ROI字段为字符串
        if (item.revenues) {
          exportedItem.revenues = {};
          Object.keys(item.revenues).forEach(day => {
            const revenue = item.revenues[day] || 0;
            const cost = item.statCost || 0;
            const ratio = (cost !== 0) ? ((revenue / cost) * 100) : 0;
            exportedItem.revenues[day] = String(ratio.toFixed(2) + '%');
          });
        }

        // 格式化60日ROI
        if (item.roi60 !== undefined) {
          const value = item.roi60 * (item.roi0 || 0) * 100;
          exportedItem.roi60 = String(isNaN(value) ? '-' : value.toFixed(2) + '%');
        }

        return exportedItem;
      });
    }
    ,

    // 重置筛选条件
    resetFilters() {
      this.filterParams = {
        nthDayRoi: 3,
        consecutiveDays: 2,
        conditionType: 'and',
        roiCompare: -20,
        roiOperator: 'lte',   // 重置ROI运算符
        ratioCompare: -20,
        ratioOperator: 'lte'  // 重置倍率运算符
      };
      this.applyFilters();
    }, // 应用筛选条件
    applyFilters() {

      this.loading = true;
      // 根据筛选参数过滤数据
      this.applyAdvancedFilterToData();

      this.loading = false;
    }, // 计算最大连续天数的方法
    calculateMaxConsecutiveDays() {
      const results = {};

      for (const [key, data] of Object.entries(this.filteredDataMap)) {
        if (data.dates && data.dates.length > 0) {
          // 将日期字符串转换为Date对象并排序
          const sortedDates = data.dates
              .map(date => new Date(date))
              .sort((a, b) => a - b);

          if (sortedDates.length === 1) {
            results[key] = {
              ...data,
              maxConsecutiveDays: 1
            };
            continue;
          }

          let maxConsecutive = 1;
          let currentConsecutive = 1;

          // 遍历排序后的日期，计算连续天数
          for (let i = 1; i < sortedDates.length; i++) {
            // 计算两个日期之间的天数差
            const timeDiff = sortedDates[i].getTime() - sortedDates[i - 1].getTime();
            const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

            if (dayDiff === 1) {
              // 如果是连续的日期，增加计数
              currentConsecutive++;
              maxConsecutive = Math.max(maxConsecutive, currentConsecutive);
            } else if (dayDiff > 1) {
              // 如果不是连续的，重置计数
              currentConsecutive = 1;
            }
            // 如果dayDiff === 0，说明是同一天，不处理
          }

          results[key] = {
            ...data,
            maxConsecutiveDays: maxConsecutive
          };
        } else {
          results[key] = {
            ...data,
            maxConsecutiveDays: 0
          };
        }
      }

      // 更新filteredDataMap
      this.filteredDataMap = results;

      return results;
    },
    // 实现高级筛选逻辑
    applyAdvancedFilterToData() {

      this.filteredDataMap = {}
      // 过滤逻辑将在数据加载后应用
      if (!this.originalRawData || this.originalRawData.length === 0) {
        return;
      }

      // 首先计算整个时间段内游戏的平均ROI作为基准
      const gameGroupedData = this.calculateGameAverageRoi();
      // 根据筛选参数类型决定是否应用连续条件
      let filteredData;

      // 否则按单日条件筛选
      this.originalRawData.forEach(item => {
        return this.checkSingleItemCondition(item, gameGroupedData,
            this.filterParams.roiCompare,
            this.filterParams.ratioCompare);
      });

      console.log("this.filteredDataMap", this.filteredDataMap)
      // 计算最大连续天数
      // 计算最大连续天数并筛选
      const filteredByConsecutiveDays = this.filterByConsecutiveDays();


      console.log("this.filteredDataMap after calculation", filteredByConsecutiveDays);

      const filteredKeys = Object.keys(filteredByConsecutiveDays);


      // 过滤tableData5，只保留符合filteredByConsecutiveDays条件的数据
      this.tableData5 = this.tableData5.filter(item => {
        const key = `${item.promotionId}-${item.materialId}`;
        return filteredKeys.includes(key);
      });


      console.log("表格", this.tableData5)
      // 更新表格数据
      // this.tableData5 ;

      // 重置分页
      this.currentPage = 1;

      return filteredData;

    },

// 筛选连续天数大于等于设定值的数据
    filterByConsecutiveDays() {
      // 先计算所有项的最大连续天数
      this.calculateMaxConsecutiveDays();

      // 筛选出连续天数大于等于设定值的数据
      const filteredResults = {};

      for (const [key, data] of Object.entries(this.filteredDataMap)) {
        if (data.maxConsecutiveDays >= this.filterParams.consecutiveDays) {
          filteredResults[key] = data;
        }
      }

      // 返回符合条件的数据
      return filteredResults;
    },
// 添加条件评估方法
    evaluateCondition(value, threshold, operator) {
      switch (operator) {
        case 'gte': // 大于等于
          return value >= threshold;
        case 'gt':  // 大于
          return value > threshold;
        case 'lte': // 小于等于
          return value <= threshold;
        case 'lt':  // 小于
          return value < threshold;
        case 'eq':  // 等于
          return value === threshold;
        default:
          return value >= threshold; // 默认为大于等于
      }
    },
    calculateGameAverageRoi() {

      // 添加游戏维度数据 - 按相同游戏筛选
      const gameData = this.originalRawData
      // 按日期分组游戏数据
      const gameDateGroups = {};
      gameData.forEach(item => {
        const date = item.statTimeDay;
        if (!gameDateGroups[date]) {
          gameDateGroups[date] = {
            date: date,
            statCost: 0,
            roi1: 0,
            roi2: 0,
            roi3: 0,
            roi4: 0,
            roi5: 0,
            roi6: 0,
            roi7: 0
          };
        }

        // 累加消耗
        gameDateGroups[date].statCost += parseFloat(item.statCost || 0);

        if (item.revenues) {
          for (let day = 1; day <= 7; day++) {
            if (item.revenues[day] !== undefined) {
              const revenue = item.revenues[day] || 0;
              const cost = item.statCost || 0;

              // 累加当天的收入和成本
              if (gameDateGroups[date][`revenue${day}`] === undefined) {
                gameDateGroups[date][`revenue${day}`] = 0;
              }
              gameDateGroups[date][`revenue${day}`] += revenue;

              if (gameDateGroups[date][`cost${day}`] === undefined) {
                gameDateGroups[date][`cost${day}`] = 0;
              }
              gameDateGroups[date][`cost${day}`] += cost;
            }
          }
        }

// 在数据聚合完成后，计算ROI
        for (let day = 1; day <= 7; day++) {
          const totalRevenue = gameDateGroups[date][`revenue${day}`] || 0;
          const totalCost = gameDateGroups[date][`cost${day}`] || 0;
          gameDateGroups[date][`roi_${day}`] = totalCost ? (totalRevenue / totalCost) * 100 : 0;
        }

        for (let day = 1; day <= 7; day++) {
          const totalRevenue = gameDateGroups[date][`revenue${day}`] || 0;
          const totalCost = gameDateGroups[date]['revenue1'] || 0;
          gameDateGroups[date][`bl_${day}`] = totalCost ? (totalRevenue / totalCost) : 0;
        }
      });

      console.log('筛选时计算', gameDateGroups)
      return gameDateGroups;
    },
    // 检查连续条件是否满足


// 检查单个项目是否满足条件
    checkSingleItemCondition(item, gameAvgRoiMap, roiThreshold, ratioThreshold) {
      const gameDate = item.statTimeDay;
      // 检查第n日ROI条件
      const nthDay = this.filterParams.nthDayRoi;

      const nthDayRevenue = item.revenues?.[nthDay] || 0;

      const cost = item.statCost || 0;

      const nthDayRoi = cost > 0 ? (nthDayRevenue / cost) * 100 : 0;

      // 获取游戏中对应日期的平均ROI
      const gameAvgNthDayRoi = gameAvgRoiMap[`${gameDate}`]['roi_' + nthDay] || 0;

      // 第n日ROI低于游戏平均值的百分比
      const roiBelowGame = gameAvgNthDayRoi > 0 ? (nthDayRoi - gameAvgNthDayRoi) / gameAvgNthDayRoi * 100 : 0;

      // 根据条件类型判断是否满足筛选
      // 根据选择的运算符判断ROI条件
      let roiCondition = this.evaluateCondition(roiBelowGame, roiThreshold, this.filterParams.roiOperator);


      console.log('第n日ROI低于游戏平均值的百分比', gameDate, item.promotionId, item.materialId, nthDayRoi, gameAvgNthDayRoi, "差值", roiBelowGame, roiCondition)

      // 获取游戏中对应日期的平均ROI
      const gameAvgNthDayBl = gameAvgRoiMap[`${gameDate}`]['bl_' + nthDay] || 0;

      const nthDayBl = cost > 0 ? (nthDayRevenue / item.revenues?.[1]) : 0;

      const blBelowGame = gameAvgNthDayBl > 0 ? (nthDayBl - gameAvgNthDayBl) / gameAvgNthDayBl * 100 : 0;


      // 根据选择的运算符判断倍率条件
      let ratioCondition = this.evaluateCondition(blBelowGame, ratioThreshold, this.filterParams.ratioOperator);

      console.log('第n日ROI低于游戏平均值的倍率', gameDate, item.promotionId, item.materialId, nthDayBl, gameAvgNthDayBl, "差值", blBelowGame, ratioCondition)
      // 检查是否满足条件
      let meetsCondition;
      if (this.filterParams.conditionType === 'and') {
        meetsCondition = roiCondition && ratioCondition;
      } else {
        meetsCondition = roiCondition || ratioCondition;
      }

      // 如果满足条件，将日期添加到对应计划ID和创意ID的数组中
      if (meetsCondition) {
        const key = `${item.promotionId}-${item.materialId}`;

        if (!this.filteredDataMap[key]) {
          this.filteredDataMap[key] = {
            promotionId: item.promotionId,
            materialId: item.materialId,
            dates: []
          };
        }

        // 避免重复添加日期
        if (!this.filteredDataMap[key].dates.includes(gameDate)) {
          this.filteredDataMap[key].dates.push(gameDate);
        }
      }

      return meetsCondition;


    },


    // 显示图表的方法
    showChartForCreative(row) {

      this.getPrice(row)
      // 构建图表数据
      this.prepareChartData(row);
      this.showChart = true;

      // 确保DOM更新后渲染图表
      this.$nextTick(() => {
        this.renderChart();
      });
    },
    getPrice(row) {


      this.$axios.post('/toufangWx/data/findPrice', {


        promotionId: row.promotionId,
        statTimeDay: this.value2[0],
        end: this.value2[1]

      }).then(response => {
        this.priceData = response.data.data;
        // if (this.priceData.length > 0) {
        //
        //   this.priceType = this.priceData[0].projectType
        // }
        this.processPriceDataForChart();

        console.log(this.priceType)
        // 重要：价格类型改变后需要重新渲染图表
        if (this.showChart) {
          this.$nextTick(() => {
            this.renderChart();
          });
        }
      })


    },
    processPriceDataForChart() {
      if (!this.priceData || !Array.isArray(this.priceData)) {
        return;
      }

      // 按日期分组价格数据，使用与图表相同的日期范围
      const priceDateGroups = {};
      this.priceData.forEach(item => {
        const date = item.uploadTime.split(' ')[0];
        // 确保日期在选择范围内
        if (this.isDateInRange(date)) {
          if (!priceDateGroups[date]) {
            priceDateGroups[date] = {
              date: date,
              validClickRoi: 0
            };
          }

          // 计算达成ROI：validClickCount * 100
          priceDateGroups[date].validClickRoi = (item.deepConversionWorthRate * 100 || 0);
        }
      });
      // 确保至少有14个数据点
      const filledPriceDateGroups = this.fillMissingDates(priceDateGroups);

      // 将处理后的数据添加到图表数据中
      this.addToChartData(filledPriceDateGroups);
    },
    fillMissingDates(priceDateGroups) {
      // 获取选择的日期范围
      const startDate = new Date(this.value2[0]);
      const endDate = new Date(this.value2[1]);

      // 生成完整日期范围
      const allDates = this.generateDateRange(startDate, endDate);

      // 确保至少有14个日期
      if (allDates.length < 14) {
        // 如果少于14个日期，扩展到14个
        const extendedDates = [];
        let currentDate = new Date(startDate);

        for (let i = 0; i < 14; i++) {
          const dateStr = currentDate.toISOString().split('T')[0];
          extendedDates.push(dateStr);
          currentDate.setDate(currentDate.getDate() + 1);
        }

        // 使用扩展的日期范围
        allDates.length = 0;
        allDates.push(...extendedDates);
      }

      // 创建填充后的数据对象
      const filledData = {};

      allDates.forEach(date => {
        if (priceDateGroups[date]) {
          filledData[date] = priceDateGroups[date];
        } else {
          // 对于缺失的日期，设置为null（不显示在图表上）
          filledData[date] = {
            date: date,
            validClickRoi: null
          };
        }
      });

      return filledData;
    },

// 辅助方法：检查日期是否在选择范围内
    isDateInRange(dateStr) {
      const date = new Date(dateStr);
      const startDate = new Date(this.value2[0]);
      const endDate = new Date(this.value2[1]);
      return date >= startDate && date <= endDate;
    },
    addToChartData(priceDateGroups) {
      if (!this.chartData || !this.chartData.allDates) {
        console.warn('chartData or allDates is not initialized');
        return;
      }

      // 将价格数据整合到chartData中
      this.chartData.priceValidClickRois = this.chartData.allDates.map(date =>
          priceDateGroups[date]?.validClickRoi > 0.01 ?
              priceDateGroups[date]?.validClickRoi.toFixed(2) : null
      );

      // 更新当前页面的图表数据
      this.updateCurrentChartData();
    },

// 辅助方法：更新当前页面的图表数据
    updateCurrentChartData() {
      if (!this.currentChartData || !this.chartData) {
        return;
      }

      const {startIndex, endIndex} = this.currentChartData;

      // 更新当前页面的价格数据
      this.currentChartData.priceValidClickRois =
          this.chartData.priceValidClickRois.slice(startIndex, endIndex);

      console.log("出价:", this.currentChartData.priceValidClickRois)
      // 重新渲染图表
      this.$nextTick(() => {
        this.renderChart();
      });

    },
    prepareChartData(selectedRow) {
      // 获取原始数据（未分组的详细数据）用于图表
      let originalData = [];

      // 判断是否包含计划列
      const hasPromotionColumn = this.selectedGroupFields.includes('promotionId');

      let materialData;
      if (hasPromotionColumn) {
        // 如果包含计划列，按创意+计划筛选数据
        materialData = this.originalRawData.filter(item =>
            item.materialId === selectedRow.materialId &&
            item.promotionId === selectedRow.promotionId
        );
      } else {
        // 如果不包含计划列，只按创意筛选数据
        materialData = this.originalRawData.filter(item =>
            item.materialId === selectedRow.materialId
        );
      }

      // 添加游戏维度数据 - 按相同游戏筛选
      const gameData = this.originalRawData.filter(item =>
          item.gameName === selectedRow.gameName
      );

      // 根据选择的日期范围生成完整日期序列
      const startDate = new Date(this.value2[0]);
      const endDate = new Date(this.value2[1]);
      const allDatesInRange = this.generateDateRange(startDate, endDate);

      // 按日期分组创意数据
      const materialDateGroups = {};
      materialData.forEach(item => {
        const date = item.statTimeDay;
        if (!materialDateGroups[date]) {
          materialDateGroups[date] = {
            date: date,
            statCost: 0,
            roi1: 0,
            roi2: 0,
            roi3: 0,
            roi4: 0,
            roi5: 0,
            roi6: 0,
            roi7: 0
          };
        }

        // 累加消耗
        materialDateGroups[date].statCost += parseFloat(item.statCost || 0);

        // 计算各日ROI - 使用与表格一致的逻辑
        if (item.revenues) {
          for (let day = 1; day <= 7; day++) {
            if (item.revenues[day] !== undefined) {
              const revenue = item.revenues[day] || 0;
              const cost = item.statCost || 0;
              const dayRoi = cost ? (revenue / cost) * 100 : null;
              if (materialDateGroups[date][`roi${day}`] !== undefined) {
                materialDateGroups[date][`roi${day}`] += dayRoi || 0;
              }
            }
          }
        }
      });

      // 按日期分组游戏数据
      const gameDateGroups = {};
      gameData.forEach(item => {
        const date = item.statTimeDay;
        if (!gameDateGroups[date]) {
          gameDateGroups[date] = {
            date: date,
            statCost: 0,
            roi1: 0,
            roi2: 0,
            roi3: 0,
            roi4: 0,
            roi5: 0,
            roi6: 0,
            roi7: 0
          };
        }

        // 累加消耗
        gameDateGroups[date].statCost += parseFloat(item.statCost || 0);

        if (item.revenues) {
          for (let day = 1; day <= 7; day++) {
            if (item.revenues[day] !== undefined) {
              const revenue = item.revenues[day] || 0;
              const cost = item.statCost || 0;

              // 累加当天的收入和成本
              if (gameDateGroups[date][`revenue${day}`] === undefined) {
                gameDateGroups[date][`revenue${day}`] = 0;
              }
              gameDateGroups[date][`revenue${day}`] += revenue;

              if (gameDateGroups[date][`cost${day}`] === undefined) {
                gameDateGroups[date][`cost${day}`] = 0;
              }
              gameDateGroups[date][`cost${day}`] += cost;
            }
          }
        }

// 在数据聚合完成后，计算ROI
        for (let day = 1; day <= 7; day++) {
          const totalRevenue = gameDateGroups[date][`revenue${day}`] || 0;
          const totalCost = gameDateGroups[date][`cost${day}`] || 0;
          gameDateGroups[date][`roi${day}`] = totalCost ? (totalRevenue / totalCost) * 100 : 0;
        }
      });

      console.log('游戏分组', gameDateGroups)

      // 设置图表数据，包括所有日期范围
      this.chartData = {
        allDates: allDatesInRange,

        // 创意数据
        materialAllCosts: allDatesInRange.map(date => materialDateGroups[date]?.statCost || 0),
        materialAllRois: [
          allDatesInRange.map(date => materialDateGroups[date]?.roi1 > 0.01 ? materialDateGroups[date]?.roi1.toFixed(2) : null),
          allDatesInRange.map(date => materialDateGroups[date]?.roi2 > 0.01 ? materialDateGroups[date]?.roi2.toFixed(2) : null),
          allDatesInRange.map(date => materialDateGroups[date]?.roi3 > 0.01 ? materialDateGroups[date]?.roi3.toFixed(2) : null),
          allDatesInRange.map(date => materialDateGroups[date]?.roi4 > 0.01 ? materialDateGroups[date]?.roi4.toFixed(2) : null),
          allDatesInRange.map(date => materialDateGroups[date]?.roi5 > 0.01 ? materialDateGroups[date]?.roi5.toFixed(2) : null),
          allDatesInRange.map(date => materialDateGroups[date]?.roi6 > 0.01 ? materialDateGroups[date]?.roi6.toFixed(2) : null),
          allDatesInRange.map(date => materialDateGroups[date]?.roi7 > 0.01 ? materialDateGroups[date]?.roi7.toFixed(2) : null)
        ],
        // 游戏数据
        gameAllCosts: allDatesInRange.map(date => gameDateGroups[date]?.statCost.toFixed(2) || 0),
        gameAllRois: [
          allDatesInRange.map(date => gameDateGroups[date]?.roi1 > 0.01 ? gameDateGroups[date]?.roi1.toFixed(2) : null),
          allDatesInRange.map(date => gameDateGroups[date]?.roi2 > 0.01 ? gameDateGroups[date]?.roi2.toFixed(2) : null),
          allDatesInRange.map(date => gameDateGroups[date]?.roi3 > 0.01 ? gameDateGroups[date]?.roi3.toFixed(2) : null),
          allDatesInRange.map(date => gameDateGroups[date]?.roi4 > 0.01 ? gameDateGroups[date]?.roi4.toFixed(2) : null),
          allDatesInRange.map(date => gameDateGroups[date]?.roi5 > 0.01 ? gameDateGroups[date]?.roi5.toFixed(2) : null),
          allDatesInRange.map(date => gameDateGroups[date]?.roi6 > 0.01 ? gameDateGroups[date]?.roi6.toFixed(2) : null),
          allDatesInRange.map(date => gameDateGroups[date]?.roi7 > 0.01 ? gameDateGroups[date]?.roi7.toFixed(2) : null)
        ]


      };

      // 初始化页面索引
      this.chartPageIndex = 0;
      this.updateChartPage();

      // 更新图表标题，如果是按创意+计划分组则显示两个字段
      if (hasPromotionColumn) {
        this.chartTitle = `创意 ${selectedRow.materialId} + 计划 ${selectedRow.promotionId} 数据图表`;
      } else {
        this.chartTitle = `创意 ${selectedRow.materialId} 数据图表`;
      }
    },

// 添加辅助方法：生成日期范围
    generateDateRange(startDate, endDate) {
      const dateArray = [];
      const currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split('T')[0];
        dateArray.push(formattedDate);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    // 更新图表当前页显示的数据
    // 更新图表当前页显示的数据
    updateChartPage() {
      // 计算当前页的数据起始索引
      const startIndex = this.chartPageIndex * this.chartsPerPage;
      let endIndex = startIndex + this.chartsPerPage;

      // 确保最后一页也显示数据点
      if (endIndex > this.chartData.allDates.length) {
        endIndex = this.chartData.allDates.length;
      }

      // 获取当前页的数据
      let dates = this.chartData.allDates.slice(startIndex, endIndex);
      let materialCosts = this.chartData.materialAllCosts.slice(startIndex, endIndex);
      let gameCosts = this.chartData.gameAllCosts.slice(startIndex, endIndex);
      let materialRois = [
        this.chartData.materialAllRois[0].slice(startIndex, endIndex),
        this.chartData.materialAllRois[1].slice(startIndex, endIndex),
        this.chartData.materialAllRois[2].slice(startIndex, endIndex),
        this.chartData.materialAllRois[3].slice(startIndex, endIndex),
        this.chartData.materialAllRois[4].slice(startIndex, endIndex),
        this.chartData.materialAllRois[5].slice(startIndex, endIndex),
        this.chartData.materialAllRois[6].slice(startIndex, endIndex)
      ];
      let gameRois = [
        this.chartData.gameAllRois[0].slice(startIndex, endIndex),
        this.chartData.gameAllRois[1].slice(startIndex, endIndex),
        this.chartData.gameAllRois[2].slice(startIndex, endIndex),
        this.chartData.gameAllRois[3].slice(startIndex, endIndex),
        this.chartData.gameAllRois[4].slice(startIndex, endIndex),
        this.chartData.gameAllRois[5].slice(startIndex, endIndex),
        this.chartData.gameAllRois[6].slice(startIndex, endIndex)
      ];

      // 如果数据不足chartsPerPage个，用0值填充
      while (dates.length < this.chartsPerPage) {
        if (this.chartData.allDates.length > endIndex) {
          // 扩展数据范围
          endIndex++;
          dates.push(this.chartData.allDates[endIndex - 1]);
          materialCosts.push(this.chartData.materialAllCosts[endIndex - 1]);
          gameCosts.push(this.chartData.gameAllCosts[endIndex - 1]);
          materialRois[0].push(this.chartData.materialAllRois[0][endIndex - 1]);
          materialRois[1].push(this.chartData.materialAllRois[1][endIndex - 1]);
          materialRois[2].push(this.chartData.materialAllRois[2][endIndex - 1]);
          materialRois[3].push(this.chartData.materialAllRois[3][endIndex - 1]);
          materialRois[4].push(this.chartData.materialAllRois[4][endIndex - 1]);
          materialRois[5].push(this.chartData.materialAllRois[5][endIndex - 1]);
          materialRois[6].push(this.chartData.materialAllRois[6][endIndex - 1]);
          gameRois[0].push(this.chartData.gameAllRois[0][endIndex - 1]);
          gameRois[1].push(this.chartData.gameAllRois[1][endIndex - 1]);
          gameRois[2].push(this.chartData.gameAllRois[2][endIndex - 1]);
          gameRois[3].push(this.chartData.gameAllRois[3][endIndex - 1]);
          gameRois[4].push(this.chartData.gameAllRois[4][endIndex - 1]);
          gameRois[5].push(this.chartData.gameAllRois[5][endIndex - 1]);
          gameRois[6].push(this.chartData.gameAllRois[6][endIndex - 1]);
        } else {
          // 如果已经是最后的数据，用0值填充
          dates.push(''); // 用空字符串表示无数据的日期
          materialCosts.push(0);
          gameCosts.push(0);
          materialRois[0].push(null);
          materialRois[1].push(null);
          materialRois[2].push(null);
          materialRois[3].push(null);
          materialRois[4].push(null);
          materialRois[5].push(null);
          materialRois[6].push(null);
          gameRois[0].push(null);
          gameRois[1].push(null);
          gameRois[2].push(null);
          gameRois[3].push(null);
          gameRois[4].push(null);
          gameRois[5].push(null);
          gameRois[6].push(null);
        }
      }

      // 设置当前页数据
      this.currentChartData = {
        dates: dates,
        materialCosts: materialCosts,
        gameCosts: gameCosts,
        materialRois: materialRois,
        gameRois: gameRois,
        startIndex: startIndex,
        endIndex: endIndex,
        priceValidClickRois: this.chartData.priceValidClickRois
      };

      // this.currentChartData.priceValidClickRois=this.currentChartData.gameRois[1]
      // 更新按钮状态
      this.showPrevBtn = this.chartPageIndex > 0;
      this.showNextBtn = endIndex < this.chartData.allDates.length;

      // 重新渲染图表
      this.$nextTick(() => {
        this.renderChart();
      });
    },

// 上一页
    prevChartPage() {
      if (this.chartPageIndex > 0) {
        this.chartPageIndex--;
        this.updateChartPage();
      }
    },

// 下一页
    nextChartPage() {
      const totalPages = Math.ceil(this.chartData.allDates.length / this.chartsPerPage);
      if (this.chartPageIndex < totalPages - 1) {
        this.chartPageIndex++;
        this.updateChartPage();
      }
    },
    closeP(row) {
      // 添加确认对话框
      this.$confirm(
          `确定要暂停创意 "${row.materialId}" 吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        // 用户点击确定后的操作
        const materialId = this.normalizePauseId(row.materialId);
        const promotionId = this.normalizePauseId(row.promotionId);
        const accountId = this.normalizePauseId(row.accountId);
        if (!materialId || !accountId) {
          this.$message.warning('创意ID或账号ID为空，无法暂停');
          return;
        }
        this.$axios
            .post('/toufangWx/data/closePromtionId', {
              "status_map": {[materialId]: 1},
              "legomid_status_map": {[materialId]: 1},
              "promotion_id": promotionId,
              "aadvid": accountId
            })
            .then(successResponse => {
              if (successResponse.data.code === 200) {
                this.$message({
                  message: '暂停成功!',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: '发生错误请联系管理员。',
                  type: 'warning'
                });
              }
            })
            .catch(error => {
              this.$message({
                message: '请求失败，请重试。',
                type: 'error'
              });
            });
      }).catch(() => {
        // 用户点击取消或关闭对话框
        this.$message({
          type: 'info',
          message: '已取消暂停操作'
        });
      });


    },
// 渲染图表
    // 渲染图表
    // 渲染图表
    renderChart() {
      // 销毁之前的实例（如果存在）
      if (this.myChart) {
        this.myChart.dispose();
      }

      // 初始化图表
      const chartDom = document.getElementById('roiChart');
      const myChart = this.$echarts.init(chartDom);

      // 准备x轴标签
      const xAxisLabels = [];
      for (let i = 0; i < this.chartsPerPage; i++) {
        const dataIndex = this.currentChartData.startIndex + i;
        if (dataIndex < this.chartData.allDates.length) {
          xAxisLabels.push(this.chartData.allDates[dataIndex]);
        } else {
          xAxisLabels.push(''); // 空标签
        }
      }

      // 计算所有ROI系列中的最大值
      const allRoiValues = [
        ...this.currentChartData.materialRois[0].filter(val => val !== null),
        ...this.currentChartData.materialRois[1].filter(val => val !== null),
        ...this.currentChartData.materialRois[2].filter(val => val !== null),
        ...this.currentChartData.materialRois[3].filter(val => val !== null),
        ...this.currentChartData.materialRois[4].filter(val => val !== null),
        ...this.currentChartData.materialRois[5].filter(val => val !== null),
        ...this.currentChartData.materialRois[6].filter(val => val !== null),
        ...this.currentChartData.gameRois[0].filter(val => val !== null),
        ...this.currentChartData.gameRois[1].filter(val => val !== null),
        ...this.currentChartData.gameRois[2].filter(val => val !== null),
        ...this.currentChartData.gameRois[3].filter(val => val !== null),
        ...this.currentChartData.gameRois[4].filter(val => val !== null),
        ...this.currentChartData.gameRois[5].filter(val => val !== null),
        ...this.currentChartData.gameRois[6].filter(val => val !== null)
      ].map(val => parseFloat(val)).filter(val => !isNaN(val));

      const maxRoiValue = allRoiValues.length > 0 ? Math.max(...allRoiValues) : 100;
      const yAxisMax = Math.min(Math.ceil(maxRoiValue * 1.1), 150); // 最大不超过150，同时给一点顶部空间

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: function (params) {
            // 分离创意和游戏数据
            const creativeItems = [];
            const gameItems = [];
            const otherItems = [];

            params.forEach(param => {
              const seriesName = param.seriesName;

              // 判断是创意还是游戏数据
              if (seriesName.startsWith('创意')) {
                creativeItems.push({
                  marker: param.marker,
                  seriesName: seriesName,
                  value: param.value,
                  color: param.color,
                  data: param.data
                });
              } else if (seriesName.startsWith('游戏')) {
                gameItems.push({
                  marker: param.marker,
                  seriesName: seriesName,
                  value: param.value,
                  color: param.color,
                  data: param.data
                });
              } else {

                otherItems.push({
                  marker: param.marker,
                  seriesName: seriesName,
                  value: param.value,
                  color: param.color,
                  data: param.data
                });
              }
            });

            // 构建分列显示的HTML
            let tooltipHtml = `<div style="min-width: 200px;">
                         <div style="font-weight: bold; margin-bottom: 8px; border-bottom: 1px solid #eee;">
                           ${params[0].axisValue}                         </div>`;

            // 创意列
            if (creativeItems.length > 0) {
              tooltipHtml += '<div style="display: inline-block; vertical-align: top; margin-right: 20px;">';
              tooltipHtml += '<div style="font-weight: bold; margin-bottom: 4px; color: #5470c6;">创意数据</div>';
              creativeItems.forEach(item => {
                // 判断是否为消耗数据
                let displayValue;
                if (item.seriesName.includes('消耗')) {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) + '元' : item.data;
                } else if (item.seriesName.includes('R')) {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) + '％' : item.data;
                } else {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) : item.data;
                }

                tooltipHtml += `<div style="margin: 2px 0;">
                          ${item.marker}                          <span style="display: inline-block; width: 80px;">${item.seriesName}:</span>
                          <span>${displayValue}</span>
                        </div>`;
              });
              tooltipHtml += '</div>';
            }

            // 游戏列
            if (gameItems.length > 0) {
              tooltipHtml += '<div style="display: inline-block; vertical-align: top;">';
              tooltipHtml += '<div style="font-weight: bold; margin-bottom: 4px; color: #73c0de;">游戏数据</div>';
              gameItems.forEach(item => {
                // 判断是否为消耗数据
                let displayValue;
                if (item.seriesName.includes('消耗')) {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) + '元' : item.data;
                } else if (item.seriesName.includes('R')) {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) + '％' : item.data;
                } else {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) : item.data;
                }

                tooltipHtml += `<div style="margin: 2px 0;">
                          ${item.marker}                          <span style="display: inline-block; width: 80px;">${item.seriesName}:</span>
                          <span>${displayValue}</span>
                        </div>`;
              });
              tooltipHtml += '</div>';
            }


            if (otherItems.length > 0) {

              tooltipHtml += '<div style="display: inline-block; vertical-align: top;">';
              tooltipHtml += '<div style="font-weight: bold; margin-bottom: 4px; color: #5470c6;">其他数据</div>';
              otherItems.forEach(item => {
                // 判断是否为消耗数据
                let displayValue;
                if (item.seriesName.includes('消耗')) {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) + '元' : item.data;
                } else if (item.seriesName.includes('R')) {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) + '％' : item.data;
                } else {
                  displayValue = typeof item.data === 'number' ? item.data.toFixed(2) : item.data;
                }

                tooltipHtml += `<div style="margin: 2px 10px;">
                          ${item.marker}                          <span style="display: inline-block; width: 80px;">${item.seriesName}:</span>
                          <span>${displayValue}</span>
                        </div>`;
              });
              tooltipHtml += '</div>';

            }
            tooltipHtml += '</div>';

            return tooltipHtml;
          }
        },
        toolbox: {
          feature: {
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        legend: {
          data: [
            {name: '创意消耗', icon: 'roundRect'},
            {name: '创意ROI1', icon: 'circle'},
            {name: '创意ROI2', icon: 'circle'},
            {name: '创意ROI3', icon: 'circle'},
            {name: '创意ROI4', icon: 'circle'},
            {name: '创意ROI5', icon: 'circle'},
            {name: '创意ROI6', icon: 'circle'},
            {name: '创意ROI7', icon: 'circle'},
            '\n',  // 换行
            {name: '游戏消耗', icon: 'roundRect'},
            {name: '游戏ROI1', icon: 'circle'},
            {name: '游戏ROI2', icon: 'circle'},
            {name: '游戏ROI3', icon: 'circle'},
            {name: '游戏ROI4', icon: 'circle'},
            {name: '游戏ROI5', icon: 'circle'},
            {name: '游戏ROI6', icon: 'circle'},
            {name: '游戏ROI7', icon: 'circle'}, {name: this.priceType + '出价ROI', icon: 'roundRect'},
          ], selected: {  // 控制默认选中的系列
            '游戏消耗': false,  // 默认不显示游戏消耗
            '创意ROI2': false,
            '创意ROI4': false,
            '创意ROI5': false,
            '创意ROI6': false,
            '游戏ROI2': false,
            '游戏ROI4': false,
            '游戏ROI5': false,
            '游戏ROI6': false
          },
          orient: 'horizontal',
          top: '1%',
          left: 'center',
          itemGap: 10,
          formatter: function (name) {
            if (name === '\n') return '';
            if (['创意消耗', '游戏消耗'].includes(name)) {
              return ' ' + name + ' ';
            }
            return name;
          },
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: '15%',
          top: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.currentChartData.dates,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              interval: 0,
              rotate: 45,
              formatter: function (value, index) {
                const actualIndex = this.currentChartData.startIndex + index;
                if (actualIndex < this.chartData.allDates.length) {
                  return value;
                } else {
                  return '';
                }
              }.bind(this)
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '消耗',
            min: 0,
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#999'
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: 'ROI%',
            max: yAxisMax,
            position: 'right',
            axisLine: {
              lineStyle: {
                color: '#666'
              }
            },
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],


        series: [

          // ROI配色定义
          {
            name: '创意ROI1',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[0],
            smooth: true,
            itemStyle: {
              color: '#fac858'  // 统一颜色
            },
            connectNulls: false,
            show: true
          },
          {
            name: '创意ROI2',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[1],
            smooth: true,
            itemStyle: {
              color: '#ee6666'  // 统一颜色
            },
            connectNulls: false,
            show: false
          },
          {
            name: '创意ROI3',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[2],
            smooth: true,
            itemStyle: {
              color: '#73c0de'  // 统一颜色
            },
            connectNulls: false,
            show: true
          },
          {
            name: '创意ROI4',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[3],
            smooth: true,
            itemStyle: {
              color: '#3ba272'  // 统一颜色
            },
            connectNulls: false,
            show: false
          },
          {
            name: '创意ROI5',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[4],
            smooth: true,
            itemStyle: {
              color: '#fc8452'  // 统一颜色
            },
            connectNulls: false,
            show: false
          },
          {
            name: '创意ROI6',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[5],
            smooth: true,
            itemStyle: {
              color: '#9a60b4'  // 统一颜色
            },
            connectNulls: false,
            show: false
          },
          {
            name: '创意ROI7',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.materialRois[6],
            smooth: true,
            itemStyle: {
              color: '#ea7ccc'  // 统一颜色
            },
            connectNulls: false,
            show: true
          },
          // 游戏ROI系列 - 使用与创意ROI相同的颜色，但线条样式不同
          {
            name: '游戏ROI1',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[0],
            smooth: true,
            itemStyle: {
              color: '#fac858'  // 与创意ROI1相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: true
          },
          {
            name: '游戏ROI2',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[1],
            smooth: true,
            itemStyle: {
              color: '#ee6666'  // 与创意ROI2相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: false
          },
          {
            name: '游戏ROI3',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[2],
            smooth: true,
            itemStyle: {
              color: '#73c0de'  // 与创意ROI3相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: true
          },
          {
            name: '游戏ROI4',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[3],
            smooth: true,
            itemStyle: {
              color: '#3ba272'  // 与创意ROI4相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: false
          },
          {
            name: '游戏ROI5',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[4],
            smooth: true,
            itemStyle: {
              color: '#fc8452'  // 与创意ROI5相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: false
          },
          {
            name: '游戏ROI6',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[5],
            smooth: true,
            itemStyle: {
              color: '#9a60b4'  // 与创意ROI6相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: false
          },
          {
            name: '游戏ROI7',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.gameRois[6],
            smooth: true,
            itemStyle: {
              color: '#ea7ccc'  // 与创意ROI7相同颜色
            },
            connectNulls: false,
            lineStyle: {
              type: 'dashed'  // 用虚线区分
            },
            show: true
          },
          // 创意消耗
          {
            name: '创意消耗',
            type: 'bar',
            yAxisIndex: 0,
            data: this.currentChartData.materialCosts,
            itemStyle: {
              color: '#5470c6'
            },
            barWidth: '15px',
            show: true
          },
          // 游戏消耗
          {
            name: '游戏消耗',
            type: 'bar',
            yAxisIndex: 0,
            data: this.currentChartData.gameCosts,
            itemStyle: {
              color: '#73c0de'
            },
            barWidth: '15px',
            show: false
          },
          {
            name: this.priceType + '出价ROI',
            type: 'line',
            yAxisIndex: 1,
            data: this.currentChartData.priceValidClickRois,
            smooth: true,
            itemStyle: {
              color: '#91cc75'  // 绿色系
            },
            connectNulls: false,
            show: true
          }
        ]
      };

      myChart.setOption(option);

      // 保存图表实例
      this.myChart = myChart;

      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },


// 关闭图表
    closeChart() {
      this.showChart = false;
      if (this.myChart) {
        this.myChart.dispose();
        this.myChart = null;
      }
    }
    ,
    formatRoi60Value(row) {
      const value = row.roi60 * row.roi0 * 100;
      if (isNaN(value)) {
        return '-';
      }
      return value.toFixed(2) + '%';
    },
    isFieldDisabled(field) {
      // 非层级字段始终不禁用
      if (!this.hierarchyFields.includes(field)) {
        return false;
      }

      // 获取当前选中的最高层级
      const selectedIndex = this.getHighestHierarchyIndex();

      // 如果没有选中任何层级字段，则所有层级字段都可以选择
      if (selectedIndex === -1) {
        return false;
      }

      // 获取当前字段在层级中的位置
      const fieldIndex = this.hierarchyFields.indexOf(field);

      // 已选中的字段不禁用
      if (this.selectedGroupFields.includes(field)) {
        return false;
      }

      // 只能选择相邻的层级字段
      return Math.abs(fieldIndex - selectedIndex) > 1;
    }, // 获取当前选中的最高层级索引
    getHighestHierarchyIndex() {
      let highestIndex = -1;
      for (let i = 0; i < this.hierarchyFields.length; i++) {
        if (this.selectedGroupFields.includes(this.hierarchyFields[i])) {
          highestIndex = i;
        }
      }
      return highestIndex;
    },

    handleSortChange({column, prop, order}) {
      if (prop && order) {
        this.sortBy = prop;
        this.sortOrder = order;
        // 重置到第一页
        this.currentPage = 1;
      }
    },


    handleCurrentChange(page) {
      this.currentPage = page;
    },

    // 处理每页条数变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置到第一页
    },
    formatMiniGameIncomeRoi1WithComparison(row) {
      // 如果是合计行，直接显示原始值
      if (row.statTimeDay === '合计') {
        return this.formatMiniGameIncomeRoi1(row);
      }

      // 计算当前行的ROI值
      const roi1 = row.miniGameIncomeRoi1 || 0;
      const cost = row.statCost || 0;

      if (cost === 0) {
        return '-';
      }

      const currentRatio = (roi1 / cost);
      const currentDisplay = currentRatio.toFixed(2) + '%';

      // 获取合计行的ROI值
      const summaryRatio = this.summaryRow ? this.getMiniGameIncomeRoi1Ratio(this.summaryRow) : 0;

      // 如果当前值小于合计值，显示差值并标红
      if (currentRatio < summaryRatio && summaryRatio > 0) {
        const difference = (summaryRatio - currentRatio).toFixed(2);
        return `${currentDisplay} <span style="color: #d65055;">(-${difference})</span>`;
      }

      return currentDisplay;
    }, getMiniGameIncomeRoi1Ratio(row) {
      const roi1 = row.miniGameIncomeRoi1 || 0;
      const cost = row.statCost || 0;

      if (cost === 0) return 0;
      return (roi1 / cost);
    },
    formatMiniGameIncomeRoi1(row) {
      const roi1 = row.miniGameIncomeRoi1 || 0;
      const cost = row.statCost || 0;

      if (cost === 0) {
        return '-';
      }

      const result = (roi1 / cost);
      return result.toFixed(2) + '%';
    },
    formatRevenueCostRatioWithComparison(row, day) {
      // 如果是合计行，直接显示原始值
      if (row.statTimeDay === '合计') {
        return this.formatRevenueCostRatio(row, day);
      }

      // 获取当前行的ROI值
      const currentRatio = this.getRatioValue(row, day);

      // 获取合计行的ROI值
      const summaryRatio = this.summaryRow ? this.getRatioValue(this.summaryRow, day) : 0;

      // 格式化当前行显示
      const currentDisplay = this.formatRevenueCostRatio(row, day);

      // 如果当前值小于合计值，显示差值并标红
      if (currentRatio < summaryRatio && summaryRatio > 0) {
        const difference = (summaryRatio - currentRatio).toFixed(2);
        return `${currentDisplay} <span style="color: #d65055;">(-${difference})</span>`;
      }


      // 确保返回当前显示值
      return currentDisplay;
    },
    formatStatCost(value) {
      if (value === 0) {
        return "-";
      } else if (isNaN(value)) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    }, handleBaseGroupChange(value) {
      this.selectedBaseGroup = value;
      this.updateSelectedGroupFields();
      this.updateAccountLevelFields(); // 同时更新账户层级字段
    }, handleAccountLevelChange(value) {

      console.log("怎么", this.selectedAccountLevel)
      this.selectedAccountLevel = value;
      this.updateAccountLevelFields();
    },

    // 更新账户层级字段
    updateAccountLevelFields() {
      const selectedOption = this.accountLevelOptions.find(
          option => option.value === this.selectedAccountLevel
      );

      if (selectedOption) {
        // 获取当前的基础字段（不包含日期）
        const baseFields = this.getBaseFields();

        // 合并基础字段和账户层级字段
        this.selectedGroupFields = [...baseFields, ...selectedOption.fields];

        // 确保 selectedGroupFields2 仍包含日期，用于图表
        this.selectedGroupFields2 = ['statTimeDay', ...baseFields, ...selectedOption.fields];

        this.search(false);
      }
    },
    // 更新选中的分组字段
    updateSelectedGroupFields() {
      // 获取当前选中的账户层级字段
      const currentAccountFields = this.selectedGroupFields.filter(
          field => this.hierarchyFields.includes(field)
      );

      // 根据基础分组选项设置基础字段
      let baseFields = this.getBaseFields();

      // 合并基础字段和账户层级字段
      this.selectedGroupFields = [...baseFields, ...currentAccountFields];

      this.search(false);
    },

    getFieldLabel(field) {
      const labels = {
        'statTimeDay': '日期',
        'gameName': '游戏名称',
        'accountId': '账户',
        'projectId': '项目',
        'promotionId': '计划',
        'materialId': '创意'
      };
      return labels[field] || field;
    },  // 修改 toggleGroupField 方法以支持层级单选
    // 修改原有的 toggleGroupField 方法
    toggleGroupField(field, checked) {
      // 层级字段的处理逻辑
      if (checked) {
        // 先移除所有层级字段
        this.selectedGroupFields = this.selectedGroupFields.filter(
            f => !this.hierarchyFields.includes(f)
        );

        // 添加当前选中的层级字段
        this.selectedGroupFields.push(field);

        // 根据选中的字段自动添加上级字段
        const fieldIndex = this.hierarchyFields.indexOf(field);
        for (let i = 0; i < fieldIndex; i++) {
          if (!this.selectedGroupFields.includes(this.hierarchyFields[i])) {
            this.selectedGroupFields.push(this.hierarchyFields[i]);
          }
        }
      } else {
        // 取消选中时，只移除当前字段
        const index = this.selectedGroupFields.indexOf(field);
        if (index > -1) {
          this.selectedGroupFields.splice(index, 1);
        }

        // 确保至少保留基础字段
        const baseFields = this.getBaseFields();
        const hasBaseFields = baseFields.every(field =>
            this.selectedGroupFields.includes(field)
        );

        if (!hasBaseFields) {
          this.selectedGroupFields = [...baseFields];
        }
      }

      this.search(false);
    },

    // 获取当前基础字段
    getBaseFields() {
      switch (this.selectedBaseGroup) {
        case 'date':
          return ['statTimeDay']; // 如果选择按日期分组，则包含日期
        case 'game':
          return ['gameName'];
        case 'date-game':
          return ['statTimeDay', 'gameName'];
        default:
          return ['gameName']; // 默认不包含日期
      }
    },

    handleGroupChange() {
      // 空实现，实际处理在toggleGroupField中完成
    },

    // 修改现有的 sortRevenueCostRatio 方法以适配分页
    sortRevenueCostRatio(a, b, day) {
      // 这个方法现在主要用于自定义排序列
      const ratioA = this.getRatioValue(a, day);
      const ratioB = this.getRatioValue(b, day);
      return ratioA - ratioB;
    },

    getRatioValue(row, day) {
      if (!row.revenues) return 0;

      const revenue = row.revenues[day] || 0;
      const cost = row.statCost || 0;

      if (cost === 0) return 0;
      return (revenue / cost) * 100;
    },
    formatRevenueCostRatio(row, day) {
      if (!row.revenues) {
        return '-';
      }

      const revenue = row.revenues[day] || 0;
      const cost = row.statCost || 0;

      if (cost === 0) return '-';
      const ratio = ((revenue / cost) * 100).toFixed(2);

      // 如果结果为0，显示为'-'
      // if (parseFloat(ratio) === 0) return '-';

      return `${ratio}%`;
    }, // 修改processGroupedData方法以支持动态分组
    processGroupedData(rawData) {
      const grouped = {};

      // 创建分组键生成函数
      const generateGroupKey2 = (item) => {
        return this.selectedGroupFields2.map(field => item[field]).join('-');
      };

      rawData.forEach(item => {
        const key = generateGroupKey2(item);

        if (!grouped[key]) {
          grouped[key] = {
            statTimeDay: item.statTimeDay,
            gameName: item.gameName,
            projectId: item.projectId,
            promotionId: item.promotionId,
            accountId: item.accountId,
            materialId: item.materialId,
            statCost: item.statCost || 0,  // 初始化为当前项的消耗值
            revenues: {}
          };

          // 初始化revenues对象的所有可能的dateDelay键
          rawData.filter(i => generateGroupKey2(i) === key)
              .forEach(i => {
                if (!grouped[key].revenues[i.dateDelay]) {
                  grouped[key].revenues[i.dateDelay] = 0;
                }
              });
        } else {
          // 取最大消耗值
          grouped[key].statCost = Math.max(grouped[key].statCost, item.statCost || 0);
        }
        // 累加收入
        grouped[key].revenues[item.dateDelay] = (grouped[key].revenues[item.dateDelay] || 0) +
            (item.statAttributionMicroGame24HAmount || 0);

      });
      console.log("先分组", Object.values(grouped))
      return Object.values(grouped);
    },// 修改 processGroupedData2 方法以适配新的数据结构
    processGroupedData2(processedData) {
      const grouped = {};

      // 使用 selectedGroupFields 进行分组（不包含日期）
      const generateGroupKey = (item) => {
        return this.selectedGroupFields.map(field => item[field]).join('-');
      };

      processedData.forEach(item => {
        const key = generateGroupKey(item);

        if (!grouped[key]) {
          grouped[key] = {
            statTimeDay: item.statTimeDay, // 保留日期字段用于图表
            gameName: item.gameName,
            projectId: item.projectId,
            promotionId: item.promotionId,
            accountId: item.accountId,
            materialId: item.materialId,
            statCost: 0,  // 重置为0，后续累加,
            revenues: {} , // 保留收入数据
            status: item.status || '未知' // 显式保留 status 字段
          };

          // 如果存在miniGameIncomeRoi1字段，初始化它
          if (item.miniGameIncomeRoi1 !== undefined) {
            grouped[key].miniGameIncomeRoi1 = 0; // 重置为0，后续累加
          }
        }

        // 累加消耗
        grouped[key].statCost += item.statCost || 0;
        grouped[key].status = item.status || grouped[key].status; // 合并时优先保留新值

        // 修改 processGroupedData2 方法中的收入数据合并部分
// 合并收入数据（保留所有日期的数据）
        Object.keys(item.revenues || {}).forEach(day => {
          if (!grouped[key].revenues[day]) {
            grouped[key].revenues[day] = 0;
          }

          // 检查日期是否小于等于距离今天的天数
          const today = new Date(); // 今天日期
          const endDate = new Date(this.value2[1]); // 选择的结束日期

          // 计算数据日期距离结束日期的天数
          const timeDiffToEnd = today.getTime() - endDate.getTime();
          const dayDiffToEnd = Math.ceil(timeDiffToEnd / (1000 * 3600 * 24));


          // 如果day（ROI天数）大于等于数据日期距离今天的天数，则收入设为0
          if (parseInt(day) >= dayDiffToEnd) {
            grouped[key].revenues[day] += 0; // 将收入设为0
          } else {
            grouped[key].revenues[day] += item.revenues[day] || 0;
          }
        });


        // 如果存在miniGameIncomeRoi1字段，进行求和
        if (item.miniGameIncomeRoi1 !== undefined) {
          grouped[key].miniGameIncomeRoi1 = (grouped[key].miniGameIncomeRoi1 || 0) + (item.miniGameIncomeRoi1 || 0);
        }
      });

      return Object.values(grouped);
    },


    // 修改addSummaryRow方法以适应新结构
    addSummaryRow() {
      if (!this.tableData5 || this.tableData5.length === 0) return null;

      const summary = {
        statTimeDay: '合计',
        gameName: '',
        projectId: '',
        promotionId: '',
        accountId: '',
        materialId: '',
        statCost: 0,
        miniGameIncomeRoi1: 0,  // 添加miniGameIncomeRoi1字段
        revenues: {}
      };

      // 初始化所有可能的dateDelay键
      this.tableData5.forEach(item => {
        Object.keys(item.revenues || {}).forEach(day => {
          if (!summary.revenues[day]) {
            summary.revenues[day] = 0;
          }
        });
      });

      // 计算合计值
      this.tableData5.forEach(item => {
        summary.statCost += item.statCost || 0;
        summary.miniGameIncomeRoi1 += item.miniGameIncomeRoi1 || 0;  // 累加miniGameIncomeRoi1
        Object.keys(item.revenues || {}).forEach(day => {
          summary.revenues[day] += item.revenues[day] || 0;
        });
      });

      this.summaryRow = summary;  // 保存合计行
      return summary;
    }
    ,
    changeFiter() {

      if (this.person !== '') {


        // this.tableData5 = this.tableData5.filter(item => item.c_author === this.person)
      }


    },

    getCellClass({column}) {

      console.log(column)
      if (column.prop === 'cAmount') {
        return 'table-number2'
      }
      return ''
    },
    get() {

      this.$axios
          .get('/toufangWx/data/getDefault?type=' + this.form.type, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.form.allDivisionScale = successResponse.data.data

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })
    },
    change() {


      this.$axios
          .post('/toufangWx/data/updateDefault', this.form)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '更新' + this.form.type + '默认值成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    formDate(date) {
      // 将Excel日期转换为JavaScript日期
      const jsDate = new Date((date - 25569) * 86400 * 1000);
      // 将JavaScript日期转换为指定格式：yyyy-MM-dd
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    , changeGame() {

      if (this.valueGame === "") {

        this.$notify(
            {
              title: '错误',
              message: '请选择游戏',
              type: 'warning'
            }
        );

      }


    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。(可能还有边距/边框等值，需要根据实际情况加上)
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },

    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },


    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    },
    value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return value.toFixed(2)

      } else {

        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    },
    value_format4(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {

        return value
      }
    }, findGame() {

      this.$axios
          .get('/toufangWx/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, handleClick(tab, event) {

      console.log(tab.name)

    },

    search(flag) {
      if (this.valueGame === "") {

        this.$notify(
            {
              title: '错误',
              message: '请选择游戏',
              type: 'warning'
            }
        );

        return;
      }

      this.statusCache={}

      this.currentPage = 1;
      // this.pageSize = 20;

      if (this.checkedCities.length < 2) {

        this.items = []

      } else {

        this.items = ["7", "15", "30", "45", "60", "75", "90", "105", "120", "135", "150"]
      }

      if (flag) {

        console.log("手动选条件")

        localStorage.setItem("ToufangSelfWX", JSON.stringify({
          name: this.valueGame,
          date: this.value2,
          a: this.activeName,
          checkedCities: this.checkedCities,
          date2: this.value5
        }))
      } else {
        console.log("获取选条件")
        if (localStorage.getItem("ToufangSelfWX") != null) {

          console.log("自动刷")


          this.valueGame = JSON.parse(localStorage.getItem("ToufangSelfWX")).name

          this.value2 = JSON.parse(localStorage.getItem("ToufangSelfWX")).date

          this.activeName = JSON.parse(localStorage.getItem("ToufangSelfWX")).a

          this.value5 = JSON.parse(localStorage.getItem("ToufangSelfWX")).date2
        }

      }
      if (this.value2 && this.value2.length === 2) {
        const startDate = new Date(this.value2[0]);
        const endDate = new Date(this.value2[1]);
        const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        if (diffDays > 60) {
          this.$message({
            message: '时间范围不能超过60天',
            type: 'warning'
          });
          return; // 阻止继续执行
        }
      }

      this.maxHeight = window.innerHeight - 250;

      if (this.value2.length > 1) {

        this.loading = true
        this.$axios
            .post('/toufangWx/data/findDy', {
              statTimeDay: this.value2[0],
              gameName: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2[1],
              param: "",
              author: this.valuePerson == null ? '' : this.valuePerson
            })
            .then(successResponse => {

              const rawData = successResponse.data.data;

              this.originalRawData = [...rawData]; // 保存未分组
              const mockData = rawData
              //将1-7日合并
              // const mockData = this.processGroupedData(rawData);
              const hasMaterialId = this.selectedGroupFields.includes('materialId');


              if (!hasMaterialId) {
                // 如果没有选中"创意"，则查询searchPro并进行数据匹配
                // 如果没有选中"创意"，则查询searchPro并进行数据匹配
                this.searchProAndMerge(mockData).then(() => {
                  // 在 searchProAndMerge 完成后再执行 searchSixtyData
                  const onlyGameGrouped = this.selectedGroupFields.length === 2 &&
                      this.selectedGroupFields.includes('gameName') && this.selectedGroupFields.includes('statTimeDay');

                  if (onlyGameGrouped) {
                    // 如果只按游戏分组，则调用searchSixtyData
                    this.searchSixtyData();
                  }
                });


              } else {
                if (this.selectedGroupFields.length === 6) {

                  this.tableData5 = mockData
                } else {
                  this.tableData5 = this.processGroupedData2(mockData);
                }

                console.log(this.tableData5)

                this.optionsPerson = [...new Set(this.tableData5.map(item => item.c_author))];

                const summaryRow = this.addSummaryRow();

                if (summaryRow) {
                  this.tableData5.unshift(summaryRow);
                }

                this.fetchStatusForItems();
              }
              this.loading = false
            })

      }
    },

    async fetchStatusForItems() {
      this.statusCache = {};
      const promises = this.tableData5.map(async (item) => {
        const key = `${item.accountId}-${item.materialId}`;

        // 如果已经缓存过状态，则直接使用缓存
        if (this.statusCache[key]) {
          item.status = this.statusCache[key];
          return;
        }

        try {
          const response = await this.$axios.post('/toufangWx/data/findStatus', {
            accountId: item.accountId,
            materialId: item.materialId
          });

          const status = response.data.data || '未知'; // 假设接口返回 status 字段
          this.statusCache[key] = status; // 缓存状态
          // item.status = status;
          this.$set(item, 'status', status); // 使用 $set 确保响应式更新
        } catch (error) {
          console.error(`查询状态失败: ${key}`, error);
          item.status = '查询失败'; // 设置默认值
        }
      });

      await Promise.all(promises); // 等待所有请求完成
    },
    // 添加新的按计划分组方法
    processGroupedByPromotion(processedData) {
      const grouped = {};

      // 创建分组键生成函数
      const generateGroupKey = (item) => {
        return this.selectedGroupFields3.map(field => item[field]).join('-');
      };

      processedData.forEach(item => {
        const key = generateGroupKey(item);

        if (!grouped[key]) {
          grouped[key] = {
            statTimeDay: item.statTimeDay,
            gameName: item.gameName,
            projectId: item.projectId,
            promotionId: item.promotionId,
            accountId: item.accountId,
            materialId: item.materialId,
            statCost: item.statCost || 0,  // 初始化为当前项的消耗值
            revenues: {...(item.revenues || {})},  // 复制收入数据,
            status: item.status,
          };


        } else {
          // 分组后消耗求和（而不是取最大值）
          grouped[key].statCost += item.statCost || 0;

          // 合并收入数据
          Object.keys(item.revenues || {}).forEach(day => {
            if (!grouped[key].revenues[day]) {
              grouped[key].revenues[day] = 0;
            }
            grouped[key].revenues[day] += item.revenues[day] || 0;
          });


        }
      });

      return Object.values(grouped);
    },// 新增方法：查询searchPro并合并数据
    searchProAndMerge(rawData) {
      // 先按计划(promotionId)进行初步分组处理
      const initialGroupedData = this.processGroupedByPromotion(rawData);

      return this.$axios
          .post('/toufangWx/data/findDyOnPromtion', {
            statTimeDay: this.value2[0],
            gameName: this.valueGame == null ? '' : this.valueGame,
            currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
            end: this.value2[1],
            param: "",
            author: this.valuePerson == null ? '' : this.valuePerson
          })
          .then(successResponse => {
            const proData = successResponse.data.data;
            console.log('searchPro数据:', proData);

            // 将searchPro数据根据日期和计划ID匹配到初步分组数据中
            if (proData && Array.isArray(proData)) {
              // 创建proData的映射，使用cDate和campaignId作为键
              const proDataMap = {};
              proData.forEach(item => {
                const key = (item.cDate || '') + '-' + (item.campaignId || '');
                proDataMap[key] = item;
              });

              // 匹配initialGroupedData和proData
              initialGroupedData.forEach(mockItem => {
                const key = (mockItem.statTimeDay || '') + '-' + (mockItem.promotionId || '');
                if (proDataMap[key]) {
                  mockItem.miniGameIncomeRoi1 = proDataMap[key].miniGameIncomeRoi1 || 0;
                }
              });
            }

            // 再根据用户选择的分组字段进行最终分组
            this.tableData5 = this.processGroupedData2(initialGroupedData);
            this.optionsPerson = [...new Set(this.tableData5.map(item => item.c_author))];

            const summaryRow = this.addSummaryRow();
            if (summaryRow) {
              this.tableData5.unshift(summaryRow);
            }

            this.loading = false;
          })
          .catch(error => {
            console.error('searchPro查询失败:', error);
            // 即使查询失败也继续处理原始数据
            this.tableData5 = this.processGroupedData2(initialGroupedData);
            this.optionsPerson = [...new Set(this.tableData5.map(item => item.c_author))];

            const summaryRow = this.addSummaryRow();
            if (summaryRow) {
              this.tableData5.unshift(summaryRow);
            }

            this.loading = false;
          });
    },
    searchSixtyData() {

      this.$axios
          .post('/toufangWx/data/findDySixtyDay', {
            statTimeDay: this.value2[0],
            gameName: this.valueGame == null ? '' : this.valueGame,
            end: this.value2[1],
          })
          .then(successResponse => {


                const proData = successResponse.data.data;

                if (proData && Array.isArray(proData)) {
                  // 创建proData的映射，使用cDate和campaignId作为键
                  const proDataMap = {};
                  proData.forEach(item => {
                    const key = (item.uploadDate || '') + '-' + (item.gameName || '');
                    proDataMap[key] = item;
                  });

                  // 匹配initialGroupedData和proData
                  this.tableData5.forEach(mockItem => {
                    const key = (mockItem.statTimeDay || '') + '-' + (mockItem.gameName || '');
                    if (proDataMap[key]) {
                      mockItem.roi60 = proDataMap[key].roi60 || 0;
                      mockItem.roi0 = proDataMap[key].roi0 || 0;
                    }
                  });

                  console.log('最终', this.tableData5)
                  this.tableKey += 1;

                  this.$nextTick(() => {
                    this.$refs['tableData1'].doLayout();
                  })
                }
              }
          )
          .catch(error => {
            console.error('searchSixtyData查询失败:', error);
          });


    }
  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {


    this.updateSelectedGroupFields();
    this.height = window.innerHeight;
    this.findGame()
    this.valueGame = JSON.parse(localStorage.getItem("ToufangSelfWX")).name

    this.value2 = JSON.parse(localStorage.getItem("ToufangSelfWX")).date

    this.activeName = JSON.parse(localStorage.getItem("ToufangSelfWX")).a

    this.value5 = JSON.parse(localStorage.getItem("ToufangSelfWX")).date2
    // this.search(false)

  }


}
</script>
<style>

.yugu {
  color: #d65055;
  font-weight: 540;

  //font-family: Georgia, 'Times New Roman', serif;
}

.yugu2 {
  color: #3a8ee6;
  //font-family: Georgia, 'Times New Roman', serif;
  font-weight: 500;
}
</style>

<style type="text/css">

*::-webkit-scrollbar {
  width: 5px;
  height: 12px;
  background-color: transparent;
}

.table-number {
  //font-family: 'Consolas', monospace;
  font-size: 12px;
  color: #4b4b4f;
  text-align: right;
}

.table-header {
  font-family: '思源黑体', sans-serif;
  font-size: 14px;
}

.updated-marker-icon {
  color: #e39f0b;
  font-size: 14px;
  margin-left: 5px;
  vertical-align: middle;
}

.bbb1 {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 96%;
  min-height: 85vh;
  display: flex;
  flex-direction: column;

}

.bbb1::after {
  content: "";
  display: table;
  clear: both;
}

</style>


<style scoped>
.advanced-filter-container {
  border: 1px solid #ebeef5;
  transition: all 0.3s;
}

.style-title {
  font-size: 12px;
  color: #606266;
  margin-right: 5px;
}


.chart-navigation {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-info {
  font-size: 14px;
  color: #666;
}

/* 为导航按钮添加样式 */
.chart-navigation .el-button {
  position: absolute;
  top: 0;
  transform: translateY(-50%);
}

.chart-navigation .el-button:nth-child(1) {
  left: 20px;
}

.chart-navigation .el-button:nth-child(3) {
  right: 20px;
}

.red {

  color: #d65055;

}

.drawer-content {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}

.drawer-actions {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.chart-drawer {
  .el-drawer__body {
    overflow-y: auto;
  }
}

.green {

  color: #5daf34;
}

/* Vue2 语法 */
.chart-container {
  padding: 20px;
  width: 97%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-select2 {
  margin-bottom: 20px;
  width: 100%;
}

/deep/ .el-tabs__item {
  font-size: 15px; /* 字体大小 */
  font-family: '思源黑体', sans-serif; /* 字体类型 */
  color: #565454; /* 默认颜色 */
  font-weight: bold; /* 字重 */
}

/* Vue2 兼容写法 */
::v-deep .el-tabs__nav {
  font-weight: bold;
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.96);

}

/deep/ .el-range-input {
  background-color: rgba(248, 245, 245, 0.94);

}
</style>
